<template>
  <div>
    <common-dialog
      ref="dialog"
      width="920px"
      :show-save-button="false"
      unit="车辆"
      edit-title
      form-label-width="165px"
      id-key="CarID"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="isSubmit?api.submit:api.save"
      @details-opened="onDetailsOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      close-on-saved
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        基础信息
        <el-row class="row-border form1">
          <el-row>
            <el-col :span="12">
              <el-form-item label="归属机构" prop="DpId">
                <tree-select
                  ref="treeSelect"
                  :props="props"
                  :options="TreeData"
                  :value="data.DpId"
                  :clearable="true"
                  :accordion="true"
                  :parentSelect="true"
                  placeholder="请选择"
                  @node-select="onTreeSelect($event)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车牌号" prop="CarNo">
                <el-input v-model="data.CarNo" placeholder="请填写车牌号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="车辆颜色" prop="Color">
                <el-select v-model="data.Color"  >
                  <el-option v-for="item in colorList" :key="item.DataId" :value="item.DataName"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="购车日期" prop="BuyDate">
                <el-date-picker
                  v-model="data.BuyDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="车辆品牌" prop="Brand">
                <!-- <el-select v-model="data.Brand" @change="setBrand" :placeholder="data.DpId?'请选择':'请先选择归属机构'">
                  <el-option v-for="item in brandList" :key="item" :value="item"/>
                </el-select> -->
                <el-input v-model="data.Brand" placeholder="请填写车辆品牌"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车系" prop="Series">
                <!-- <el-input v-model="data.Series" placeholder="请填写车系"></el-input> -->
                <!-- <el-select v-model="data.Series" @change="setMF" :placeholder="data.Brand?'请选择':'请先选择车辆品牌'">
                  <el-option v-for="item in seriesList" :key="item" :value="item"/>
                </el-select> -->
                <el-input v-model="data.Series" placeholder="请填写车系"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车座数" prop="Seat">
                <el-input v-model="data.Seat" @blur="checkNum('Seat')" type="number" placeholder="请填写车座数"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="资产类型" prop="AssetsType">
                <el-select v-model="data.AssetsType">
                  <el-option :value="0" label="自营"/>
                  <el-option :value="1" label="加盟"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车辆排量" prop="Volume">
                <el-input v-model="data.Volume" type="number" @blur="checkNum('Volume')" placeholder="请填写车辆排量"><template slot="append">L</template></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排挡类别" prop="GearType">
                <el-select v-model="data.GearType"  >
                  <el-option :value="0" label="自动"/>
                  <el-option :value="1" label="手动"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车架号" prop="Vin">
                <el-input v-model="data.Vin" placeholder="请填写车架号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车牌颜色" prop="PlateColor">
                <el-select v-model="data.PlateColor"  >
                  <el-option v-for="item in plateList" :key="item.DataId" :value="item.DataName"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发动机号" prop="EngineNo">
                <el-input v-model="data.EngineNo" placeholder="请填写发动机号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="培训车型" prop="TrainCarType">
                <el-select v-model="data.TrainCarType">
                  <el-option v-for="item in trainList" :key="item.DataId" :value="item.DataName"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="许可证号" prop="LicenceNo">
                <el-input v-model="data.LicenceNo" placeholder="请填写许可证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报废日期" prop="ScrapDate">
                <el-date-picker
                  v-model="data.ScrapDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册日期" prop="RegisterDate">
                <el-date-picker
                  v-model="data.RegisterDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="年审日期" prop="ReviewDate">
                <el-date-picker
                  v-model="data.ReviewDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="技术等级" prop="Lv">
                <el-select v-model="data.Lv" clearable>
                  <el-option value="一级"/>
                  <el-option value="二级"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产厂家" prop="Manufactor">
                <el-input v-model="data.Manufactor" placeholder="请填写生产厂家"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="车辆图片" prop="PicUrls" class="is-required">
                <div>
                  <el-upload
                    class="file-up"
                    :action="host + '/api/Common/UploadPicture'"
                    list-type="picture-card"
                    :data="{ dic: 'Car' }"
                    :show-file-list="true"
                    accept=".jpg,.png,.jpeg"
                    :on-success="(res,file,fileList) => { onSuccess(res,file,fileList,'PicUrls') }"
                    :headers="headers"
                    :file-list="PicUrls"
                    :on-preview="handlePictureCardPreview"
                    :on-exceed="onExceed"
                    :before-upload="beforePhotoUpload"
                    :on-remove="($event) => { picRemove($event,'PicUrls') }">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="Remark">
                <el-input type="textarea" v-model="data.Remark" placeholder="请填写备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <!-- 附件信息
        <el-row class="row-border file-form">
        </el-row> -->
        扩展信息
        <el-row class="row-border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="车辆吨位" prop="Tonnage">
                <el-input v-model="data.Tonnage" v-int placeholder="请填写车辆吨位"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="燃料类型" prop="FuelType">
                <el-select v-model="data.FuelType" clearable>
                  <el-option value="汽油"/>
                  <el-option value="柴油"/>
                  <el-option value="电动"/>
                  <el-option value="其他"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车辆长度" prop="Length">
                <el-input v-model="data.Length" v-int placeholder="请填写车辆长度"><template slot="append">mm</template></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车辆宽度" prop="Width">
                <el-input v-model="data.Width" v-int placeholder="请填写车辆宽度"><template slot="append">mm</template></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车辆高度" prop="Height">
                <el-input v-model="data.Height" v-int placeholder="请填写车辆高度"><template slot="append">mm</template></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="变速箱类型" prop="GearboxType">
                <el-select v-model="data.GearboxType" clearable>
                  <el-option value="手动"/>
                  <el-option value="自动"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="行驶证登记日期" prop="LicenseRegisterDate">
                <el-date-picker
                   
                  v-model="data.LicenseRegisterDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="技术等级有效期" prop="ExpireDate">
                <el-date-picker
                   
                  v-model="data.ExpireDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="道路教学车辆" prop="TeachCar">
                <el-select v-model="data.TeachCar" clearable>
                  <el-option value="是"/>
                  <el-option value="否"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="副加速踏板" prop="SpeedPedal">
                <el-select v-model="data.SpeedPedal" clearable>
                  <el-option value="有"/>
                  <el-option value="没有"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="副离合器踏板" prop="ClutchPedal">
                <el-select v-model="data.ClutchPedal" clearable>
                  <el-option value="有"/>
                  <el-option value="没有"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="教学车辆标识" prop="TeachLogo">
                <el-select v-model="data.TeachLogo" clearable>
                  <el-option value="有"/>
                  <el-option value="没有"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="副后视镜" prop="Mirror">
                <el-select v-model="data.Mirror" clearable>
                  <el-option value="有"/>
                  <el-option value="没有"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="副制动踏板" prop="BrakePedal">
                <el-select v-model="data.BrakePedal" clearable>
                  <el-option value="有"/>
                  <el-option value="没有"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="灭火器" prop="Extinguisher">
                <el-select v-model="data.Extinguisher" clearable>
                  <el-option value="有"/>
                  <el-option value="没有"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="其他安全防护装置" prop="OtherDevice">
                <el-select v-model="data.OtherDevice" clearable>
                  <el-option value="有"/>
                  <el-option value="没有"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="档位个数" prop="Gear">
                <el-input v-model="data.Gear" type="number" placeholder="请填写档位个数"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="file-form">
            <el-col :span="24">
              <el-form-item label="行驶证图片" class="is-required">
                <div>
                  <el-upload
                    class="file-up"
                    :action="host + '/api/Common/UploadPicture'"
                    list-type="picture-card"
                    :show-file-list="true"
                    accept=".jpg,.png,.jpeg"
                    :on-success="(res,file,fileList) => { onSuccess(res,file,fileList,'LicencePicUrls') }"
                    :headers="headers"
                    :file-list="LicencePicUrls"
                    :on-preview="handlePictureCardPreview"
                    :on-exceed="onExceed"
                    :before-upload="beforePhotoUpload"
                    :on-remove="($event) => { picRemove($event,'LicencePicUrls') }">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="file-form">
            <el-col :span="24">
              <el-form-item label="技术证明" class="is-required">
                <div>
                  <el-upload
                    class="file-up"
                    :action="host + '/api/Common/UploadPicture'"
                    list-type="picture-card"
                    :show-file-list="true"
                    accept=".jpg,.png,.jpeg"
                    :on-success="(res,file,fileList) => { onSuccess(res,file,fileList,'TechPicUrls') }"
                    :headers="headers"
                    :file-list="TechPicUrls"
                    :on-preview="handlePictureCardPreview"
                    :on-exceed="onExceed"
                    :before-upload="beforePhotoUpload"
                    :on-remove="($event) => { picRemove($event,'TechPicUrls') }">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="file-form">
            <el-col :span="24">
              <el-form-item label="车型证明" class="is-required">
                <div>
                  <el-upload
                    class="file-up"
                    :action="host + '/api/Common/UploadPicture'"
                    list-type="picture-card"
                    :show-file-list="true"
                    accept=".jpg,.png,.jpeg"
                    :on-success="(res,file,fileList) => { onSuccess(res,file,fileList,'CarPicUrls') }"
                    :headers="headers"
                    :file-list="CarPicUrls"
                    :on-preview="handlePictureCardPreview"
                    :on-exceed="onExceed"
                    :before-upload="beforePhotoUpload"
                    :on-remove="($event) => { picRemove($event,'CarPicUrls') }">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="file-form">
            <el-col :span="24">
              <el-form-item label="购置证明" class="is-required">
                <div>
                  <el-upload
                    class="file-up"
                    :action="host + '/api/Common/UploadPicture'"
                    list-type="picture-card"
                    :show-file-list="true"
                    accept=".jpg,.png,.jpeg"
                    :on-success="(res,file,fileList) => { onSuccess(res,file,fileList,'BuyPicUrls') }"
                    :headers="headers"
                    :file-list="BuyPicUrls"
                    :on-preview="handlePictureCardPreview"
                    :on-exceed="onExceed"
                    :before-upload="beforePhotoUpload"
                    :on-remove="($event) => { picRemove($event,'BuyPicUrls') }">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="file-form">
            <el-col :span="24">
              <el-form-item label="出厂合格证或登记证明" class="is-required">
                <div>
                  <el-upload
                    class="file-up"
                    :action="host + '/api/Common/UploadPicture'"
                    list-type="picture-card"
                    :show-file-list="true"
                    accept=".jpg,.png,.jpeg"
                    :on-success="(res,file,fileList) => { onSuccess(res,file,fileList,'RegPicUrls') }"
                    :headers="headers"
                    :file-list="RegPicUrls"
                    :on-preview="handlePictureCardPreview"
                    :on-exceed="onExceed"
                    :before-upload="beforePhotoUpload"
                    :on-remove="($event) => { picRemove($event,'RegPicUrls') }">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="file-form">
            <el-col :span="24">
              <el-form-item label="终端安装图片" class="is-required">
                <div>
                  <el-upload
                    class="file-up"
                    :action="host + '/api/Common/UploadPicture'"
                    list-type="picture-card"
                    :show-file-list="true"
                    accept=".jpg,.png,.jpeg"
                    :on-success="(res,file,fileList) => { onSuccess(res,file,fileList,'TermPicUrls') }"
                    :headers="headers"
                    :file-list="TermPicUrls"
                    :on-preview="handlePictureCardPreview"
                    :on-exceed="onExceed"
                    :before-upload="beforePhotoUpload"
                    :on-remove="($event) => { picRemove($event,'TermPicUrls') }">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="file-form">
            <el-col :span="24">
              <el-form-item label="其他图片">
                <div>
                  <el-upload
                    class="file-up"
                    :action="host + '/api/Common/UploadPicture'"
                    list-type="picture-card"
                    :show-file-list="true"
                    accept=".jpg,.png,.jpeg"
                    :on-success="(res,file,fileList) => { onSuccess(res,file,fileList,'OtherPicUrls') }"
                    :headers="headers"
                    :file-list="OtherPicUrls"
                    :on-preview="handlePictureCardPreview"
                    :on-exceed="onExceed"
                    :before-upload="beforePhotoUpload"
                    :on-remove="($event) => { picRemove($event,'OtherPicUrls') }">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </template>
      <template #footer>
        <template v-if="data.CarId">
          <el-button type="danger" v-if="isPass&&!data.Scrap" @click="scrap">报 废</el-button>
          <el-button type="success" v-if="data.Scrap" @click="cancel">撤销报废</el-button>
        </template>
        <el-button type="warning" @click="toSave(0)">保 存</el-button>
        <el-button type="primary" v-if="data.Status==0||data.Status==2" @click="toSave(1)">提 交</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <pic-dialog ref="picDialog" @del="data.SignUrl=''" />
    <el-dialog :visible.sync="dialogVisible" title="查看图片">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import treeSelect from "@/components/common/treeSelect";
import picDialog from "@/views/sy/template/picDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    treeSelect,
    picDialog
  },
  data() {
    return {
      data: {
        CarId: 0,
        DpId: null,
        DpName: "",
        CarNo: "",
        Color: "",
        BuyDate: "",
        Brand: "",
        Series: "",
        Seat: 0,
        AssetsType: null,
        Volume: 0,
        GearType: null,
        Vin: "",
        PlateColor: "",
        EngineNo: "",
        TrainCarType: "",
        LicenceNo: "",
        ScrapDate: "",
        RegisterDate: "",
        ReviewDate: "",
        Lv: "",
        Manufactor: "",
        PicUrls: "",
        Remark: "",
        //------------
        Tonnage: null,
        FuelType: "",
        Length: null,
        Width: null,
        Height: null,
        GearboxType: "",
        LicenseRegisterDate: "",
        ExpireDate: "",
        TeachCar: "",
        SpeedPedal: "",
        ClutchPedal: "",
        TeachLogo: "",
        Mirror: "",
        BrakePedal: "",
        Extinguisher: "",
        OtherDevice: "",
        Gear: null,
        LicencePicUrls: "",
        TechPicUrls: "",
        CarPicUrls: "",
        BuyPicUrls: "",
        RegPicUrls: "",
        TermPicUrls: "",
        OtherPicUrls: "",
        Status: 0,
        Scrap: false,
      },
      api: require("@/api/schoolmanage/car").default,
      dpApi: require("@/api/basic/dp").default,
      basicApi: require("@/api/basic/data").default,
      brandApi: require("@/api/basic/basic/clpp").default,
      TreeData: [],
      trainList: [],
      plateList: [],
      colorList: [],
      // brandList: [],
      // seriesList: [],
      PicUrls: [],
      LicencePicUrls: [],
      TechPicUrls: [],
      CarPicUrls: [],
      BuyPicUrls: [],
      RegPicUrls: [],
      TermPicUrls: [],
      OtherPicUrls: [],
      dialogVisible: false,
      dialogImageUrl: "",
      headers: { Authorization: "" },
      props: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      isSubmit: false,
      isMB: this.$store.state.isMB,
      rules: {
        DpId: [{ required: true, message: "请选择归属机构" }],
        CarNo: [{ required: true, message: "请填写车牌号" }],
        Color: [{ required: true, message: "请填写车辆颜色" }],
        Brand: [{ required: true, message: "请填写车辆品牌" }],
        Series: [{ required: true, message: "请填写车系" }],
        BuyDate: [{ required: true, message: "请选择购车日期" }],
        // Mobile: [
        //   { required: false, message: "请填写手机号码" },
        //   { validator: this.$commonJs.validateRules.validPhone },
        // ],
        // Seat: [{ required: true, message: "请填写车座数" }],
        AssetsType: [{ required: true, message: "请选择资产类型" }],
        GearType: [{ required: true, message: "请选择排挡类别" }],
        // Volume: [{ required: true, message: "请填写车辆排量" }],
        Vin: [{ required: true, message: "请填写车架号" }],
        PlateColor: [{ required: true, message: "请填写车牌颜色" }],
        EngineNo: [{ required: true, message: "请填写发动机号" }],
        TrainCarType: [{ required: true, message: "请选择培训车型" }],
        ScrapDate: [{ required: true, message: "请选择报废日期" }],
        // RegisterDate: [{ required: true, message: "请选择注册日期" }],
        Manufactor: [{ required: true, message: "请填写生产厂家" }],
        LicenseRegisterDate: [{ required: true, message: "请选择行驶证登记日期" }],
      },
    };
  },
  computed: {
    host() {
      return window.location.origin;
    },
    isPass() {
      if(this.data.ScrapDate) {
        return (new Date(this.data.ScrapDate)).getTime() < new Date().getTime() - 86400000;
      } else {
        return false;
      }
    },
  },
  methods: {
    onCreateOpened(data) {
      this.getBasic();
      this.getTreeData();
    },
    onEditOpened(data) {
      this.getBasic();
      this.getTreeData(true);
      var urlArr = ["PicUrls","LicencePicUrls","TechPicUrls","CarPicUrls","BuyPicUrls","RegPicUrls","TermPicUrls","OtherPicUrls",];
      urlArr.forEach(e => {
        if(data[e]) {
          var arr = data[e].split(",");
          arr.forEach(n => {
            this[e].push({ url: "/api" + n, url2: n });
          })
        }
      });
    },
    onDetailsOpened(data) {
      this.onEditOpened(data);
    },
    getTreeData(t) {
      this.dpApi.getAuthList({ DpTypes: [2,3,4,5], Status: 3, NoReturnParent: true }).then((res) => {
        this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
        if(t) {
          this.$refs.treeSelect.setData(this.data.DpId);
          if(this.data.Brand) {
            this.setBrand(this.data.Brand,true);
          }
        } else if(this.data.DpId) {
          // this.$refs.treeSelect.setData(this.data.DpId);
        }
      });
    },
    onTreeSelect(t) {
      if (!t) {
        this.data.DpId = 0;
        this.data.DpName = "";
      } else {
        this.data.DpId = t.DpId;
        this.data.DpName = t.DpName;
      }
      this.data.Brand = "";
      this.data.Series = "";
      // this.data.Manufactor = "";
      // this.seriesList = [];
    },
    getBasic() {
      this.plateList = [];
      this.trainList = [];
      this.colorList = [];
      this.basicApi.list({Status:1}).then(res => {
        res.Data.forEach(e => {
          switch (e.ClassName) {
            case "培训车型":
              this.trainList.push(e);
              break;
            case "车牌颜色":
              this.plateList.push(e);
              break;
            case "车辆颜色":
              this.colorList.push(e);
              break;
          }
        })
      });
      // this.brandList = [];
      // this.brandApi.getBrands().then(res => {
      //   if(res.Code == 0) {
      //     this.brandList = res.Data;
      //   } else {
      //     this.$message.error("获取车辆品牌信息失败");
      //   }
      // })
    },
    setBrand(v,t) {
      // this.seriesList = [];
      if(!(t===true)) {
        this.data.Series = "";
        // this.data.Manufactor = "";
      }
      // this.brandApi.getSeries(v).then(res => {
      //   if(res.Code == 0) {
      //     this.seriesList = res.Data;
      //   }
      // })
    },
    // setMF(v) {
    //   this.brandApi.getManufactor(this.data.Brand,v).then(res => {
    //     if(res.Code == 0) {
    //       this.data.Manufactor = res.Data;
    //     }
    //   })
    // },
    beforePhotoUpload(file) {
      this.headers.Authorization = "Bearer " + localStorage.getItem("token");
      const is500k = file.size/1024 <= 500;
      if(!is500k) {
        this.$message.error("照片大小不能超过500k")
      }
      return is500k;
    },
    onSuccess(res,file,fileList,name) {
      if(res.Code==0) {
        this[name].push({ url: "/api" + res.Data, url2: res.Data })
      } else {
        fileList.splice(fileList.length-1,1);
        this.$message.error(res.Msg);
      }
    },
    onExceed() {
      this.$message.error("只能上传一张图片");
    },
    picRemove(file,name) {
      this[name].forEach((e,i) => {
        if(e.url == file.url) {
          this[name].splice(i,1);
          return;
        }
      })
    },
    toSave(type) {
      this.isSubmit = type==1;
      this.save();
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onBeforeSave(data) {
      if(!this.data.DpId) {
        this.$message.error("请选择归属机构");
        return false;
      }
      if(this.data.Gear<0||(this.data.Gear&&this.data.Gear%1!=0)) {
        this.$message.error("档位个数需为正整数");
        return false;
      }
      var urlArr = ["PicUrls","LicencePicUrls","TechPicUrls","CarPicUrls","BuyPicUrls","RegPicUrls","TermPicUrls"];
      var nameArr = ["车辆图片","行驶证图片","技术证明","车型证明","购置证明","出厂合格证或登记证明","终端安装图片"];
      for (let i = 0; i < urlArr.length; i++) {
        var m = urlArr[i];
        if(this[m].length == 0) {
          this.$message.error("请上传"+nameArr[i]);
          return false;
        }
      }
      urlArr.forEach(e => {
        this.data[e] = "";
        this[e].forEach((n,i) => {
          this.data[e] += n.url2;
          if(i < this[e].length - 1) {
            this.data[e] += ",";
          }
        });
      })
    },
    scrap() {
      this.$confirm("确认标记该车辆报废吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.scrap({ CarId: this.data.CarId, Scrap: true }).then(res => {
            if(res.Code==0) {
              this.$message.success(res.Msg);
              this.close();
              this.$emit("close-saved");
            } else {
              this.$message.error(res.Msg);
            }
          })
        })
        .catch(() => {});
    },
    cancel() {
      this.$confirm("确认撤销该车辆的报废标记吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.scrap({ CarId: this.data.CarId, Scrap: false }).then(res => {
            if(res.Code==0) {
              this.$message.success(res.Msg);
              this.close();
              this.$emit("close-saved");
            } else {
              this.$message.error(res.Msg);
            }
          })
        })
        .catch(() => {});
    },
    checkNum(name) {
      if(!(this.data[name]>0)) {
        this.data[name] = 0;
      }
    },
    onClosed() {
      this.uploading = false;
      this.$refs.treeSelect.clearHandle();
      this.plateList = [];
      this.trainList = [];
      this.colorList = [];
      // this.brandList = [];
      // this.seriesList = [];
      this.PicUrls = [];
      this.LicencePicUrls = [];
      this.TechPicUrls = [];
      this.CarPicUrls = [];
      this.BuyPicUrls = [];
      this.RegPicUrls = [];
      this.TermPicUrls = [];
      this.OtherPicUrls = [];
    },
  },
};
</script>
<style lang="scss">
.file-form{
  .el-form-item__label {
    line-height: 83px;
  }
  .file-up{
    display: inline-block;
    height: 83px;
    .el-upload--picture-card {
      height: 80px;
      width: 80px;
      line-height: 90px;
    }
    .el-upload-list__item,.el-upload-list__item-actions {
      height: 80px;
      width: 80px;
    }
  }
}
.file-text{
  .el-form-item__label {
    line-height: 28px;
  }
}
.el-icon-close-tip {
  display: none !important;
}
.form1 {
  .el-form-item__label {
    width: 95px !important;
  }
  .el-form-item__content {
    margin-left: 95px !important;
  }
}
</style>